import React, { Component } from 'react';

import { Button } from 'reactstrap';

class TableTopPagination extends Component {
  constructor(props) {
    super(props);
    this.changeHandler = this.changeHandler.bind(this);
  }

  changeHandler(dir) {
    if (dir === 'prev') this.prevPage();
    else this.nextPage();
  }

  nextPage() {
    const requestedPage = this.props.currentPage + 1;
    if (requestedPage <= this.props.totalPages) this.props.onChange(requestedPage);
  }

  prevPage() {
    const requestedPage = this.props.currentPage - 1;
    if (requestedPage >= 1) {
      this.props.onChange(requestedPage);
    }
  }

  render() {
    const { currentPage, totalPages, totalItems } = this.props;

    return (
      <div className="d-flex align-items-center mb-2 font-weight-base top-paging">
        <div>
          <span className="text-placeholder">Page</span> {currentPage}{' '}
          <span className="text-placeholder">of</span> {totalPages}
        </div>
        <Button color="link" className="p-0 ml-3 mr-2" onClick={() => this.changeHandler('prev')}>
          <div className="dropdown-toggle left-toggle" />
        </Button>
        <Button color="link" className="p-0" onClick={() => this.changeHandler('next')}>
          <div className="dropdown-toggle right-toggle" />
        </Button>
        <div className="text-dark-red ml-auto">Total: {totalItems}</div>
      </div>
    );
  }
}

export default TableTopPagination;



// WEBPACK FOOTER //
// ./src/components/table/TableTopPagination.js